/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Insert_Transcript_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Insert new transcript event" |
*
* @param {Event_Insert_Transcript_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_insert_transcript_aria_label = /** @type {((inputs?: Event_Insert_Transcript_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Insert_Transcript_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer un nouvel evenement de transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Transkriptereignis einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci nuovo evento di trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить новое событие транскрипции")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar nuevo evento de transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入新的转录事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいトランスクリプトイベントを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया ट्रांसक्रिप्ट इवेंट डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir novo evento de transcrição")
	return /** @type {LocalizedString} */ ("Insert new transcript event")
});